<template>
  <div class="animated fadeIn">
    <br>
    <b-row>
      <b-col lg="12">
        <b-card v-if="tieneAcceso === false">
          <div slot="header">
            <strong>Base Asegurado</strong>
          </div>
          <b-row>
            <b-col lg="12">
              <p>Acceso restringido</p>
            </b-col>
          </b-row>
        </b-card>

        <b-card v-if="tieneAcceso === true">
          <div slot="header">
            <strong>Filtros del Informe</strong>
          </div>

              <b-row class="my-1">
              <b-col sm="2">
                <label>Póliza</label>
              </b-col>
              <b-col sm="2">
                <b-input-group> 
                    <b-form-input 
                        type="number" 
                        v-model="datosFormulario.poliza"
                        @change="consulta_poliza()"
                        >
                    </b-form-input>
                    <!-- <b-input-group-prepend class="input-group-append">
                        <b-button type="submit" class="fa fa-search" variant="primary"></b-button>
                    </b-input-group-prepend> -->
                </b-input-group>
                <span class="error-validacion-campo">
                    {{ mensajeValidacionCampo.poliza }}
                </span>     
              </b-col>
              <b-col sm ="2">
                <b-input-group>
                  <b-form-input type="text" v-model="datosFormulario.IdNacionAse" :disabled="true"/>
                </b-input-group>
              </b-col>
              <b-col sm="3">
                <b-input-group>
                  <b-form-input type="text" v-model="datosFormulario.NombreAseg" :disabled="true"/>
                </b-input-group>
              </b-col>
              <b-col sm="3">
              </b-col>
            </b-row>

            <b-row class="my-1">
              <b-col sm="2">
                <label>Ejecutivo</label>
              </b-col>
              <b-col sm="1">
                <b-input-group> 
                    <b-form-input 
                        type="text" 
                        v-model="datosFormulario.ejecutivo"
                        :disabled="true"
                        >
                    </b-form-input>
                </b-input-group>
              </b-col>
              <b-col sm="1">
                 <label>Fecha Reporte</label>
              </b-col>  
              <b-col sm="2">
                <b-input-group> 
                    <b-form-input 
                        type="text" 
                        v-model="datosFormulario.fereporte"
                        :disabled="true"
                        >
                    </b-form-input>
                </b-input-group>
              </b-col>
            </b-row>
  
           <b-row>
             <b-col sm="12">
               <b-form-group>
                 <b-form-radio-group v-model="datosFormulario.selected">
                   <b-form-radio   name="some-radios" value="ACT">Sólo Líneas Activas</b-form-radio>
                   <b-form-radio   name="some-radios" value="ULT">Últimos dos Años</b-form-radio>
                 </b-form-radio-group>
               </b-form-group>
             </b-col>
           </b-row>

           <b-row class="my-1">
              <b-col sm="2">
                <label>Ver</label>
              </b-col>
              <b-col sm="3">
                
              <b-form-checkbox-group
                  v-model="selectedTemp"
                  :options="ckdTemp"
                  class="mb-3"
                  value-field="item"
                  text-field="name"
                  disabled-field="notEnabled"
                ></b-form-checkbox-group>
              </b-col>
            </b-row>

          
          <div slot="footer">
                <div class="form-actions text-right">
                    <el-row>
                            <el-col>
                                <b-button variant="primary" @click="buscar" :disabled="disableConsultar"> <i class="fa fa-search"></i> Consultar</b-button>
                                <b-button variant="primary" @click="pre_insertar" style="margin-left: 10px;"><i class="fa fa-eraser"></i> Limpiar</b-button>
                                <b-button variant="primary" @click="descargarExcel" style="margin-left: 10px;"><i class="fa fa-file-excel-o"></i> Exportar</b-button>
                            </el-col> 
                               
                    </el-row>                
                </div>
            </div>            
        </b-card>

        <b-card v-if="tieneAcceso === true">
          <div slot="header">
            <strong>Detalle por Póliza</strong>
          </div>
          <b-row>
            <b-col lg="6">
              <!-- <b-button v-if="hasPoliza" variant="primary" @click="nuevoContacto">Agregar Contacto</b-button> -->
            </b-col>  
            <b-col lg="6">
              <b-form-group label label-for="filtroProceso">
                <b-form-input
                  id="filtroProceso"
                  type="text"
                  placeholder="Filtrar"
                  v-model="filters[0].value"
                ></b-form-input>
              </b-form-group>
            </b-col>
          </b-row>
          <br>
          <b-row>
            <b-col lg="12">             
              <div ref="refTable">
              <data-tables ref="refTable1"
                :data="data"
                name="table"
                class="table-responsive"
                :current-page.sync="pagina"
                :table-props="tableProps2"
                :filters="filters"
                :page-size="10"
                :pagination-props="{ background: true, pageSizes: [10, 20, 50] }"
                layout="table"
              >
                <el-table-column
                  v-for="title in titles"
                  :min-width="title.minwidth" 
                  :prop="title.prop"
                  :label='title.label'
                  :key="title.label"
                  :align="title.align"
                  sortable="custom"
                  :formatter="formatter"
                  name="table"
                  class="table-responsive"
                ></el-table-column>

                <el-table-column
                  v-if="selectedTemp.includes('LT')"
                  prop="aermontoest"
                  label="Monto Temporal"
                  align="right"
                  sortable="custom"
                  :formatter="formatter"
                  width="200">
                </el-table-column>
                          
                <el-table-column 
                  v-if="selectedTemp.includes('LT')"
                  prop="aercobnomprop"
                  label="Cobertura %"
                  align="right"
                  sortable="custom"
                  :formatter="formatter"
                  width="120">
                </el-table-column>
                          
                <el-table-column
                  v-if="selectedTemp.includes('LT')"
                  prop="aervigdesde"
                  align="center"
                  sortable="custom"
                  label="Vigencia Desde"
                  width="120">
                </el-table-column>
                          
                <el-table-column
                  v-if="selectedTemp.includes('LT')"
                  prop="aervighasta"
                  label="Vigencia Hasta"
                  align="center"
                  sortable="custom"
                  width="120">
                </el-table-column>

                <el-table-column
                  prop="uso"
                  label="Uso"
                  align="center"
                  sortable="custom"
                  width="120"
                  type="text">
                </el-table-column>

                <el-table-column
                  prop="condventa"
                  label="Condición de Venta"
                  align="left"
                  sortable="custom"
                  width="120"
                  type="text">
                </el-table-column>

                <el-table-column
                  prop="matrizsub"
                  label="Matriz / Sublínea"
                  align="center"
                  sortable="custom"
                  width="90"
                  type="text">
                </el-table-column>

                <el-table-column
                  prop="linneg"
                  label="Línea de Negocios"
                  align="center"
                  sortable="custom"
                  width="90"
                  type="text">
                </el-table-column>

                <el-table-column
                  prop="plazo"
                  label="Plazo (días)"
                  align="center"
                  sortable="custom"
                  width="90"
                  type="text">
                </el-table-column>

               <el-table-column
                  prop="observ"
                  label="Observaciones"
                  align="left"
                  sortable="custom"
                  width="170"
                  type="text">
                </el-table-column>

              </data-tables>
              </div>
            </b-col>
          </b-row>
        </b-card>
      </b-col>
    </b-row>
    
  </div>
</template>
<script>
import { Switch as cSwitch } from "@coreui/vue";
import axios from "axios";
import { tablasMixin } from "@/components/mixins/tablasMixin";
import apiPorcAprLineas from "@/components/services/apiPorcAprLineas";
import { globalesMixin } from "@/components/mixins/globalesMixin";
import { utilesMixin } from "@/components/mixins/utilesMixin";
import Datepicker from "vuejs-datepicker";
import { es } from "vuejs-datepicker/dist/locale";
import moment from 'moment';
import download from "downloadjs";
import Multiselect from 'vue-multiselect';

import XLSX from "xlsx";
import apiAtradius from '@/components/services/apiAtradius';

export default {
  name: "Detalle por Póliza",
  mixins: [tablasMixin, globalesMixin, utilesMixin],
  components: {
    cSwitch
  },
  data: function() {
    return {
      hasPoliza : false,
      exportar: false,
      tieneAcceso: true,
      es: es,
      busqueda: "",
      pagina: 1,
      paginaAnterior: 1,
      labelIcon: {
        dataOn: "\u2713",
        dataOff: "\u2715"
      },

      selectedTemp:[],
      ckdTemp: [
          { item:  'LT', name: 'Líneas Temporales' }
        ],
    
      data: [],
      disableConsultar:false,
      totmtosol:0,
      totmtoapr:0,
      nombreexcel: "Detalle por Póliza",
      titles: [
        {
          prop: "idnacion",
          label: "Id. Nacional",
          align: "left",
          minwidth:'120'
        },
        {
          prop: "sujriesgo",
          label: "Nro. SR",
          align: "left",
          minwidth:'100'
        },
        {
          prop: "cliente",
          label: "Cliente",
          align: "left",
          minwidth:'320'
        },
        {
          prop: "clasif",
          label: "Clasificación",
          align: "center",
          minwidth:'120'
        },
        {
          prop: "moncumulo",
          label: "Moneda Cúmulo",
          align: "center",
          minwidth:'100'
        },
        {
          prop: "cumulo",
          label: "Cúmulo",
          align: "right",
          minwidth:'150'
        },
        {
          prop: "cliestado",
          label: "Estado Cliente",
          align: "left",
          minwidth:'90'
        },
        {
          prop: "pais",
          label: "País",
          align: "left",
          minwidth:'100'
        },
        {
          prop: "vigdesde",
          label: "Vigencia Desde",
          align: "center",
          minwidth:'90'
        },
        {
          prop: "vighasta",
          label: "Vigencia Hasta",
          align: "center",
          minwidth:'90'
        },
        {
          prop: "moneda",
          label: "Moneda Póliza",
          align: "center",
          minwidth:'90'
        },
        {
          prop: "mtosol",
          label: "Monto Solicitado",
          align: "right",
          minwidth:'100'
        },
        {
          prop: "mtoapr",
          label: "Monto Aprobado",
          align: "right",
          minwidth:'100'
        },
        {
          prop: "porcind",
          label: "% Individual",
          align: "center",
          minwidth:'80'
        },
        {
          prop: "estado",
          label: "Estado",
          align: "left",
          minwidth:'90'
        }
        /*{
          prop: "uso",
          label: "Uso",
          align: "center",
          minwidth:'120'
        },
        {
          prop: "condventa",
          label: "Condición de Venta",
          align: "center",
          minwidth:'120'
        },
        {
          prop: "matrizsub",
          label: "Matriz / Sublínea",
          align: "center",
          minwidth:'90'
        },
        {
          prop: "linneg",
          label: "Línea de Negocios",
          align: "center",
          minwidth:'90'
        },
        {
          prop: "plazo",
          label: "Plazo (días)",
          align: "center",
          minwidth:'90'
        },
        {
          prop: "observ",
          label: "Observaciones",
          align: "center",
          minwidth:'170'
        },*/
      ],
      filters: [
        {
          value: '',
          filterFn: (row, filter) => {
            return Object.keys(row).some(prop => {
           return row[prop].toString().toLowerCase().indexOf(filter.value.toLowerCase()) > -1
            }) 
          }
        }
      ],

      mostrarFechas: true,
      datosFormulario: {
          ejecutivo:"",
          fereporte:"",
          poliza:"",
          idnacion:"",
          sujriesgo:"",
          IdNacionAse :"",
          NombreAseg:"",
          cliente:"",
          clasif:"",
          moncumulo:"",
          cumulo:"",
          cliestado:"",
          pais:"",
          vigdesde: "",
          vighasta:"",
          moneda:"",
          mtosol:"", 
          mtoapr:"",
          porcind:"",
          estado:"",
          aermontoest:"",
          aercobnomprop:"",
          aervigdesde:"",
          aervighasta:"",
          uso:"", 
          condventa:"",
          matrizsub:"",
          linneg:"",
          plazo:"",
          observ:""
      },

      value: null,
      datosFormularioEstado: [],
      mensajeValidacionCampo: {},

      tableProps2: {
        summaryMethod: this.totales,
        showSummary: true,
        maxHeight: 400,
        rowKey: "id"
      },
    };
  },
  components:{
    Datepicker,
    Multiselect
  },
  methods: {

    addTag (newTag) {
      const tag = {
        name: newTag,
        code: newTag.substring(0, 2) + Math.floor((Math.random() * 10000000))
      }
      this.options.push(tag)
      this.value.push(tag)
    },

    cambiarFechas(){
      if(this.datosFormulario.selected == 'A') {
            this.mostrarFechas = false;
      }else{
            this.mostrarFechas = true;
      }
    },

    formatNumber(n) {
        n = String(n).replace(/\D/g, "");
        return n === '' ? n : Number(n).toLocaleString();
    },

    totales(param) {
 
      const { columns, data } = param;

      const sums = [];

      columns.forEach((column, index) => {
          if (index === 0) {
              sums[index] = 'Total';
              return;
          }

          const values = data.map(item => Number(item[column.property]));
          
          if ((column.property == "mtosol") || (column.property == "mtoapr")){
             if (!values.every(value => isNaN(value))) {
                 sums[index] = this.$numeral((values.reduce((prev, curr) => {
                     const value = Number(curr);

                     if (!isNaN(value)) {
                         return prev + curr;
                     } else {
                         return prev;
                     }
                  }, 0))).format();
                //  console.log(sums[index]);
                 if (column.property == "mtosol") {
                  this.totmtosol = sums[index];
                 }
                  if (column.property == "mtoapr") {
                  this.totmtoapr = sums[index];
                 }

             } else {
                 sums[index] = '';
             }
          } else {
                 sums[index] = '';
          }  
          
          if  (column.property == "porcind") {
            // console.log(this.$numeral(this.totmtoapr).value());
            // console.log(this.$numeral(this.totmtosol).value());
            sums[index] = this.$numeral((this.$numeral(this.totmtoapr).value() / this.$numeral(this.totmtosol).value())).format('0%');
            
          }
      });

      return sums;
    },

    exportarExcel() {
        this.$nextTick(function() {
          var tabla = document.getElementById("tableExcel");
          var data = XLSX.utils.table_to_sheet(tabla);
          const workbook = XLSX.utils.book_new();
          const filename = "Export";
          XLSX.utils.book_append_sheet(workbook, data, filename);
          XLSX.writeFile(workbook, `${filename}.xlsx`);
        });
    },

    llenaArrayLista(data, valor, texto, isDate){
      var arr = new Array();
      for(var i = 0; i < data.length; i++){
          var obj = new Object();
          if (isDate){
            obj.value = this.convierteFecha(data[i][valor]);
            obj.text = this.convierteFecha(data[i][texto]);
          } else {
            obj.value = data[i][valor].toString();
            obj.text = data[i][texto];
          }
          arr.push(obj);
        }
        return arr;
    },
    
    pre_insertar() {
      this.$Progress.start();
      this.disableConsultar = false; 
      this.exportar = false;
      this.mensajeValidacionCampo = {};
      this.data = [];
      this.value = null;

      this.datosFormulario.ejecutivo ='0';
      this.datosFormulario.poliza = "";
      this.datosFormulario.fereporte = "";
      this.datosFormulario.IdNacionAse ="";
      this.datosFormulario.NombreAseg ="";
      this.hasPoliza = false;

      return apiPorcAprLineas
        .pre_insercion(
          this.$session.get("mail"),
          this.$session.get("usuarioInterno")
        )  
        .then(response => {
          response.data = this.keysMinuscula(response.data);

          //Bloqueo usuario no valido
          if (response.data.args_out.usuarioval == 's'){
            this.tieneAcceso = true;
          }else{
            this.tieneAcceso = false;
          }

          this.datosFormulario.ejecutivo='';

          var lista_data = response.data.res;
          for(var i = 0; i < lista_data.length; i++){
        
              this.datosFormulario.fereporte = lista_data[i]["fereporte"];
              this.datosFormulario.selected = lista_data[i]["selected"];
          }
    
          this.datosFormularioEstado = response.data.festado;
          
          this.$Progress.finish();
        })
        .catch(error => {
          this.crearNotificacion("Error de sistema", error, "error");
          this.$Progress.finish();
        });
    },

    buscar() {
      this.$Progress.start();
      this.disableConsultar = true;

      var p_email= this.$session.get("mail");

      this.datosFormulario.poliza == ''? '' : this.datosFormulario.poliza;
   
      var p_poliza = this.datosFormulario.poliza == ''? '0' : this.datosFormulario.poliza;
      
      return apiPorcAprLineas
      .recuperar(
        p_email, p_poliza, this.datosFormulario.selected
        ).then( (response)=>{

            response.data = this.keysMinuscula(response.data); 
            this.data = response.data.res;

            if (this.data != null){
            this.exportar = true;
            } else {
            this.exportar = false;
            }

            this.disableConsultar = false;
            this.$Progress.finish();
        })
        .catch((error)=>{
          this.disableConsultar = false;
          this.$Progress.finish();
          this.mensaje= error;
          this.variant="danger";
          this.showAlert();
        });
    },

    formatter(row, column) {
      if ((column.property == "fecha")  && row[column.property]) {
        return this.configurarFechaLat(this.convierteFecha(row[column.property]));
      } else if ((column.property == "mtosol") || (column.property == "mtoapr") || (column.property == "cumulo") 
                   || (column.property == "aermontoest") || (column.property == "aercobnomprop") && row[column.property]) {
        if (row[column.property] == 0 || row[column.property] == "0") {
          return row[column.property];
        } else {
          return this.$numeral(row[column.property]).format();
        }
      } else {
        return row[column.property];
      }
    },
    
    descargarExcel: function () {
      var cuerpo = "";
      var xl159618 =
        "padding:0px; mso-ignore:padding; color:black; font-size:11.0pt; font-weight:400; font-style:normal; text-decoration:none; font-family:Calibri, sans-serif; mso-font-charset:0; mso-number-format:General; text-align:general; vertical-align:bottom; mso-background-source:auto; mso-pattern:auto; white-space:nowrap;";
      var xl689618 =
        "padding:0px; mso-ignore:padding; color:black; font-size:12.0pt; font-weight:700; font-style:normal; text-decoration:none; font-family:Calibri, sans-serif; mso-font-charset:0; mso-number-format:General; text-align:center; vertical-align:middle; border-top:.5pt solid windowtext; border-right:.5pt solid windowtext; border-bottom:.5pt solid windowtext; border-left:.5pt solid windowtext; background:#BDD7EE; mso-pattern:black none; white-space:nowrap;";
      var xl649618 =
        "padding:0px; mso-ignore:padding; color:black; font-size:11.0pt; font-weight:400; font-style:normal; text-decoration:none; font-family:Calibri, sans-serif; mso-font-charset:0; mso-number-format:General; text-align:general; vertical-align:bottom; border:.5pt solid windowtext; mso-background-source:auto; mso-pattern:auto; white-space:nowrap;";
      var xl679618 =
        "padding:0px; mso-ignore:padding; color:black; font-size:11.0pt; font-weight:400; font-style:normal; text-decoration:none; font-family:Calibri, sans-serif; mso-font-charset:0; mso-number-format:General; text-align:center; vertical-align:bottom; border:.5pt solid windowtext; mso-background-source:auto; mso-pattern:auto; white-space:nowrap;";
      var xl719618 =
        "padding:0px; mso-ignore:padding; color:black; font-size:12.0pt; font-weight:700; font-style:normal; text-decoration:none; font-family:Calibri, sans-serif; mso-font-charset:0; mso-number-format:General; text-align:center; vertical-align:middle; border-top:.5pt solid windowtext; border-right:.5pt solid windowtext; border-bottom:.5pt solid windowtext; border-left:.5pt solid windowtext; mso-background-source:auto; mso-pattern:auto; white-space:nowrap; mso-rotate:90;";
      var xl659618 =
        "padding:0px; mso-ignore:padding; color:black; font-size:11.0pt; font-weight:700; font-style:normal; text-decoration:none; font-family:Calibri, sans-serif; mso-font-charset:0; mso-number-format:General; text-align:general; vertical-align:bottom; border:.5pt solid windowtext; mso-background-source:auto; mso-pattern:auto; white-space:nowrap;";
      var xl289618 =
        "padding:0px; mso-ignore:padding; color:black; font-size:11.0pt; font-weight:400; font-style:normal; text-decoration:none; font-family:Calibri, sans-serif; mso-font-charset:0; mso-number-format:0,0000000000%; text-align:general; vertical-align:bottom; border:.5pt solid windowtext; mso-background-source:auto; mso-pattern:auto; white-space:nowrap;";
     
      cuerpo +=
        "<table border=0 cellpadding=0 cellspacing=0 width=730 style='border-collapse:collapse;table-layout:fixed;width:550pt'>";
      cuerpo += "\n";
      cuerpo +=
        "<col width=32 style='mso-width-source:userset;mso-width-alt:1170;width:24pt'>";
      cuerpo += "\n";
      cuerpo +=
        "<col width=130 style='mso-width-source:userset;mso-width-alt:4754;width:98pt'>";
      cuerpo += "\n";
      cuerpo +=
        "<col width=61 span=8 style='mso-width-source:userset;mso-width-alt:2230; width:46pt'>";
      cuerpo += "\n";
      cuerpo += "<col width=80 style='width:60pt'>";
      cuerpo += "\n";

      ///COLUMNAS ESCRIBIR
      cuerpo += "<tr height=20 style='height:15.0pt'>\n";
        cuerpo += "<td class=xl679618 style='border-left:none;" + xl679618 + "'>" + "Id. Nacional" + "</td>\n";
        cuerpo += "<td class=xl679618 style='border-left:none;" + xl679618 + "'>" + "Nro. SR" + "</td>\n";
        cuerpo += "<td class=xl679618 style='border-left:none;" + xl679618 + "'>" + "Cliente" + "</td>\n";
        cuerpo += "<td class=xl679618 style='border-left:none;" + xl679618 + "'>" + "Clasificación" + "</td>\n";
        cuerpo += "<td class=xl679618 style='border-left:none;" + xl679618 + "'>" + "Moneda Cúmulo" + "</td>\n";
        cuerpo += "<td class=xl679618 style='border-left:none;" + xl679618 + "'>" + "Cúmulo" + "</td>\n";
        cuerpo += "<td class=xl679618 style='border-left:none;" + xl679618 + "'>" + "Estado Cliente" + "</td>\n";
        cuerpo += "<td class=xl679618 style='border-left:none;" + xl679618 + "'>" + "País" + "</td>\n";
        cuerpo += "<td class=xl679618 style='border-left:none;" + xl679618 + "'>" + "Vigencia Desde" + "</td>\n";
        cuerpo += "<td class=xl679618 style='border-left:none;" + xl679618 + "'>" + "Vigencia Hasta" + "</td>\n";
        cuerpo += "<td class=xl679618 style='border-left:none;" + xl679618 + "'>" + "Moneda Póliza" + "</td>\n";
        cuerpo += "<td class=xl679618 style='border-left:none;" + xl679618 + "'>" + "Monto Solicitado" + "</td>\n";
        cuerpo += "<td class=xl679618 style='border-left:none;" + xl679618 + "'>" + "Monto Aprobado" + "</td>\n";
        cuerpo += "<td class=xl679618 style='border-left:none;" + xl679618 + "'>" + "% Individual" + "</td>\n";
        cuerpo += "<td class=xl679618 style='border-left:none;" + xl679618 + "'>" + "Estado" + "</td>\n";

        if (this.selectedTemp.includes('LT')){
          cuerpo += "<td class=xl679618 style='border-left:none;" + xl679618 + "'>" + "Monto Temporal" + "</td>\n";
          cuerpo += "<td class=xl679618 style='border-left:none;" + xl679618 + "'>" + "Cobertura %" + "</td>\n";
          cuerpo += "<td class=xl679618 style='border-left:none;" + xl679618 + "'>" + "Vigencia Desde" + "</td>\n";
          cuerpo += "<td class=xl679618 style='border-left:none;" + xl679618 + "'>" + "Vigencia Hasta" + "</td>\n"; 
        }

        cuerpo += "<td class=xl679618 style='border-left:none;" + xl679618 + "'>" + "Uso" + "</td>\n";
        cuerpo += "<td class=xl679618 style='border-left:none;" + xl679618 + "'>" + "Condición de Venta" + "</td>\n";
        cuerpo += "<td class=xl679618 style='border-left:none;" + xl679618 + "'>" + "Matríz / Sublínea" + "</td>\n";
        cuerpo += "<td class=xl679618 style='border-left:none;" + xl679618 + "'>" + "Línea de Negocios" + "</td>\n";
        cuerpo += "<td class=xl679618 style='border-left:none;" + xl679618 + "'>" + "Plazo (días)" + "</td>\n";
        cuerpo += "<td class=xl679618 style='border-left:none;" + xl679618 + "'>" + "Observaciones" + "</td>\n";
      cuerpo += "</tr>\n";
      
      //Data bloque 1
      // let diadiapol = '';
      // let decididor = '';
         //Data bloque 1
        var sumdata1 = [];
       
        sumdata1["A12"] = 0;
        sumdata1["A13"] = 0;
        sumdata1["A14"] = this.$numeral((this.$numeral(this.totmtoapr).value() / this.$numeral(this.totmtosol).value())).format('0%');

      for (var key in this.data) {
        
          sumdata1["A12"] += this.data[key]["mtosol"];
          sumdata1["A13"] += this.data[key]["mtoapr"];
         
        if(this.data[key]["idnacion"] === undefined){ 
          this.data[key]["idnacion"] = "";
        }
        if(this.data[key]["sujriesgo"] === undefined){ 
          this.data[key]["sujriesgo"] = "";
        }
        if(this.data[key]["cliente"] === undefined){ 
          this.data[key]["cliente"] = "";
        }
        if(this.data[key]["clasif"] === undefined){ 
          this.data[key]["clasif"] = "";
        }
        if(this.data[key]["moncumulo"] === undefined){ 
          this.data[key]["moncumulo"] = "";
        }
        if(this.data[key]["cumulo"] == undefined){ 
          this.data[key]["cumulo"] = "";
        }
        if(this.data[key]["cliestado"] == undefined){ 
          this.data[key]["cliestado"] = "";
        }
        if(this.data[key]["pais"] == undefined){ 
          this.data[key]["pais"] = "";
        }
        if(this.data[key]["vigdesde"] == undefined){ 
          this.data[key]["vigdesde"] = "";
        }
        if(this.data[key]["vighasta"] == undefined){ 
          this.data[key]["vighasta"] = "";
        }
        if(this.data[key]["moneda"] == undefined){ 
          this.data[key]["moneda"] = "";
        }
        if(this.data[key]["mtosol"] == undefined){ 
          this.data[key]["mtosol"] = "";
        }
        if(this.data[key]["mtoapr"] == undefined){ 
          this.data[key]["mtoapr"] = "";
        }
        if(this.data[key]["porcind"] == undefined){ 
          this.data[key]["porcind"] = "";
        }
        if(this.data[key]["estado"] == undefined){ 
          this.data[key]["estado"] = "";
        }
        if(this.data[key]["aermontoest"] == undefined){ 
          this.data[key]["aermontoest"] = "";
        }
        if(this.data[key]["aercobnomprop"] == undefined){ 
          this.data[key]["aercobnomprop"] = "";
        }
        if(this.data[key]["aervigdesde"] == undefined){ 
          this.data[key]["aervigdesde"] = "";
        }
        if(this.data[key]["aervighasta"] == undefined){ 
          this.data[key]["aervighasta"] = "";
        }
        if(this.data[key]["uso"] == undefined){ 
          this.data[key]["uso"] = "";
        }
        if(this.data[key]["condventa"] == undefined){ 
          this.data[key]["condventa"] = "";
        }
        if(this.data[key]["matrizsub"] == undefined){ 
          this.data[key]["matrizsub"] = "";
        }
        if(this.data[key]["linneg"] == undefined){ 
          this.data[key]["linneg"] = "";
        }
        if(this.data[key]["plazo"] == undefined){ 
          this.data[key]["plazo"] = "";
        }
        if(this.data[key]["observ"] == undefined){ 
          this.data[key]["observ"] = "";
        }

        cuerpo +="<tr height=20 style='mso-height-source:userset;height:15.0pt'>\n";
        cuerpo += "<td class=xl649618 style='border-top:none;border-left:none;" + xl649618 + "'>" + this.data[key]["idnacion"] + "</td>\n";
        cuerpo += "<td class=xl649618 style='border-top:none;border-left:none;" + xl649618 + "'>" + this.data[key]["sujriesgo"] + "</td>\n";
        cuerpo += "<td class=xl649618 style='border-top:none;border-left:none;" + xl649618 + "'>" + this.data[key]["cliente"] + "</td>\n";
        cuerpo += "<td class=xl649618 style='border-top:none;border-left:none;" + xl649618 + "'>" + this.data[key]["clasif"] + "</td>\n";
        cuerpo += "<td class=xl649618 style='border-top:none;border-left:none;" + xl649618 + "'>" + this.data[key]["moncumulo"] + "</td>\n";
        cuerpo += "<td class=xl649618 style='border-top:none;border-left:none;" + xl649618 + "'>" + this.data[key]["cumulo"] + "</td>\n";
        cuerpo += "<td class=xl649618 style='border-top:none;border-left:none;" + xl649618 + "'>" + this.data[key]["cliestado"] + "</td>\n";
        cuerpo += "<td class=xl649618 style='border-top:none;border-left:none;" + xl649618 + "'>" + this.data[key]["pais"] + "</td>\n";
        cuerpo += "<td class=xl649618 style='border-style:solid; border-width:thin; mso-number-format:\"\@\"';" + xl649618 + "'>" + this.data[key]["vigdesde"] + "</td>\n";
        if(this.data[key]["vighasta"] == 'Indefinida'){ 
          cuerpo += "<td class=xl649618 style='border-top:none;border-left:none;" + xl649618 + "'>" + this.data[key]["vighasta"] + "</td>\n";
        }
        else {
          cuerpo += "<td class=xl649618 style='border-style:solid; border-width:thin; mso-number-format:\"\@\"';" + xl649618 + "'>" + this.data[key]["vighasta"] + "</td>\n";
        };
        
        cuerpo += "<td class=xl649618 style='border-top:none;border-left:none;" + xl649618 + "'>" + this.data[key]["moneda"] + "</td>\n";
        cuerpo += "<td class=xl649618 style='border-top:none;border-left:none;" + xl649618 + "'>"  + this.$numeral(this.data[key]["mtosol"]).format("0,0") + "</td>\n";
        cuerpo += "<td class=xl649618 style='border-top:none;border-left:none;" + xl649618 + "'>"  + this.$numeral(this.data[key]["mtoapr"]).format("0,0") + "</td>\n";
        cuerpo += "<td class=xl649618 style='border-style:solid; border-width:thin; mso-number-format:\"\@\"';" + xl649618 + "'>" + this.data[key]["porcind"] + "</td>\n";
        cuerpo += "<td class=xl649618 style='border-top:none;border-left:none;" + xl649618 + "'>" + this.data[key]["estado"] + "</td>\n";  
        
        if (this.selectedTemp.includes('LT')){
           cuerpo += "<td class=xl649618 style='border-top:none;border-left:none;" + xl649618 + "'>" + this.data[key]["aermontoest"]+ "</td>\n";
           cuerpo += "<td class=xl649618 style='border-top:none;border-left:none;" + xl649618 + "'>" + this.data[key]["aercobnomprop"] + "</td>\n";
           cuerpo += "<td class=xl649618 style='border-style:solid; border-width:thin; mso-number-format:\"\@\"';" + xl649618 + "'>" + this.data[key]["aervigdesde"] + "</td>\n";
           cuerpo += "<td class=xl649618 style='border-style:solid; border-width:thin; mso-number-format:\"\@\"';" + xl649618 + "'>" + this.data[key]["aervighasta"] + "</td>\n";
        }
        
        cuerpo += "<td class=xl649618 style='border-top:none;border-left:none;" + xl649618 + "'>" + this.data[key]["uso"] + "</td>\n";
        cuerpo += "<td class=xl649618 style='border-top:none;border-left:none;" + xl649618 + "'>" + this.data[key]["condventa"] + "</td>\n";
        cuerpo += "<td class=xl649618 style='border-top:none;border-left:none;" + xl649618 + "'>" + this.data[key]["matrizsub"] + "</td>\n";
        cuerpo += "<td class=xl649618 style='border-top:none;border-left:none;" + xl649618 + "'>" + this.data[key]["linneg"] + "</td>\n";
        cuerpo += "<td class=xl649618 style='border-top:none;border-left:none;" + xl649618 + "'>" + this.data[key]["plazo"] + "</td>\n";
        cuerpo += "<td class=xl649618 style='border-top:none;border-left:none;" + xl649618 + "'>" + this.data[key]["observ"] + "</td>\n";

        cuerpo += "</tr>\n";
      }

       cuerpo += "<tr height=20 style='height:15.0pt'>\n";
       cuerpo += "<td height=20 class=xl659618 style='height:15.0pt;border-top:none;border-left: none;"+xl659618+"'>Total</td>\n";
       cuerpo += "<td></td>\n";
       cuerpo += "<td></td>\n";
      
       cuerpo += "<td></td>\n";
       cuerpo += "<td></td>\n";
       cuerpo += "<td></td>\n";
       cuerpo += "<td></td>\n";
       cuerpo += "<td></td>\n";
       cuerpo += "<td></td>\n";
       cuerpo += "<td></td>\n";
       cuerpo += "<td></td>\n";
       cuerpo += "<td class=xl659618 align=right style='border-top:none;border-left:none;"+xl659618+"'>"+this.$numeral(sumdata1["A12"]).format("0,0")+"</td>\n";
       cuerpo += "<td class=xl659618 align=right style='border-top:none;border-left:none;"+xl659618+"'>"+this.$numeral(sumdata1["A13"]).format("0,0")+"</td>\n";
       cuerpo += "<td class=xl659618 align=left style='border-style:solid; border-width:thin; mso-number-format:\"\@\"';" + xl659618 + "'>" + "<b>" + sumdata1["A14"] + "</td>\n";
       cuerpo += "<td></td>\n";
       cuerpo += "<td></td>\n";

       if (this.selectedTemp.includes('LT')){
           cuerpo += "<td></td>\n";
           cuerpo += "<td></td>\n";
           cuerpo += "<td></td>\n";
           cuerpo += "<td></td>\n";
      }
       cuerpo += "<td></td>\n";
       cuerpo += "<td></td>\n";
       cuerpo += "<td></td>\n";
       cuerpo += "<td></td>\n";
       cuerpo += "<td></td>\n";
       cuerpo += "<td></td>\n";
       cuerpo += "</tr>\n";

      //Data bloque 1
      
      this.export(
        this.generaExcelV2(this.nombreexcel, cuerpo),
        this.nombreexcel
      );
    },

    export:async function(data, filename) {
      if(typeof this.beforeFinish === 'function')
        await this.beforeFinish();
      download(data, filename,  "application/vnd.ms-excel");
    },
    
    convierteFecha(fechaEntrada){
        if((fechaEntrada != undefined) && (fechaEntrada.length != 0)){
            var fecha = new Date(fechaEntrada);

            var dia = ("0" + fecha.getUTCDate()).slice(-2);
            var mes = ("0" + (fecha.getUTCMonth() + 1)).slice(-2)
            var año = fecha.getUTCFullYear();

            fecha = dia + '-' + mes + '-' + año;

            return fecha;
        }
        else{
            return fechaEntrada;
        }
    },

    consulta_poliza: function(){
      this.$Progress.start();
      this.mensajeValidacionCampo = {};
      this.hasPoliza = false;
       
      this.datosFormulario.poliza == ''? '' : this.datosFormulario.poliza;

      var p_email= this.$session.get("mail");
      var p_ejecutivo = 0;
      var p_poliza = this.datosFormulario.poliza;

      return apiPorcAprLineas
        .consulta_poliza(
          p_email, p_ejecutivo, p_poliza
        ).then((response) => {
          response.data = this.keysMinuscula(response.data);
          
          var Listapoliza = response.data.res;
          for (var i = 0; i < Listapoliza.length; i++) {
            this.datosFormulario.poliza       = Listapoliza[i]["marpoliza"];
            this.datosFormulario.IdNacionAse  = Listapoliza[i]["peridnacion"];
            this.datosFormulario.ejecutivo  = Listapoliza[i]["ejecutivo"];
            this.datosFormulario.NombreAseg   = Listapoliza[i]["nomcontratante"];

            this.hasPoliza = true;
          }
          this.$Progress.finish();
          //this.buscar();  
        })
        .catch((error) => {
          this.mensaje= error;
          this.variant="danger";
          this.showAlert();
          this.$Progress.finish();
        });
    },
  },

  mounted() {
    this.pagina = Number(this.$route.query.pagina);
    this.pre_insertar();    
    //this.buscar();
  },

  watch: {
    pagina: function(nuevo, anterior) {
      this.paginaAnterior = anterior;
    }
  }
};
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>

<style>
  .card-header {
      background-color: #00A7D4;
      color: #fff;
  }

  .multiselect__tag {
    background: #20a8d8 !important;
  }
  .multiselect__option--highlight:after {
    background: #20a8d8 !important;
  }

  .multiselect__option--highlight {
    background: #20a8d8 !important;
}
.multiselect__tags {
    border-radius: 0px !important;
    min-height: 70px !important;
}

.el-button {
    background: #00A7D4;
}
</style>
